import {
  ColumnLayout,
  Container,
  Header,
} from '@cloudscape-design/components';
import { TS_PATHS } from 'features/plc/contracts/testStand.schema';
import React from 'react';

import ChannelCard from './ChannelCard';

function LiveDashboard() {
  return (
    <Container header={<Header variant="h2">Live Dashboard</Header>}>
      <ColumnLayout columns={2}>
        <ChannelCard
          channelLabel="Lipid channel"
          outputPaths={TS_PATHS.lipid.outputs}
        />
        <ChannelCard
          channelLabel="Aqueous channel"
          outputPaths={TS_PATHS.aqueous.outputs}
        />
      </ColumnLayout>
    </Container>
  );
}

export default LiveDashboard;
